<template>
    <div>
        <ValidationObserver ref="observer">
            <b-card>
                <b-row class="my-2">
                    <b-col>
                        <ValidationProvider
                            rules="required|min:3|alpha_spaces"
                            v-slot="{ errors }"
                            name="First name"
                        >
                            <c-input
                                inputType="text"
                                inputId="firstName"
                                labelText="First Name *"
                                v-model="authentication.firstName"
                            />
                            <span class="validate-error validate-error-red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col>
                        <ValidationProvider
                            rules="required|min:3|alpha_spaces"
                            v-slot="{ errors }"
                            name="Last name"
                        >
                            <c-input
                                inputType="text"
                                inputId="lastName"
                                labelText="Last Name *"
                                v-model="authentication.lastName"
                            />
                            <span class="validate-error validate-error-red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <b-row class="my-2">
                    <b-col>
                        <ValidationProvider
                            rules="required|max:15|min:15"
                            v-slot="{ errors }"
                            name="phone number"
                        >
                            <c-tel-input
                                class="mt-3"
                                v-model="authentication.phone"
                                inputType="number"
                            />
                            <span class="validate-error validate-error-red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col>
                        <ValidationProvider
                            rules="required|email|no-capital-first-letter"
                            v-slot="{ errors }"
                            name="email"
                        >
                            <c-input
                                class="mt-3"
                                inputType="email"
                                inputId="email"
                                labelText="Email *"
                                v-model="authentication.email"
                            />
                            <span
                                v-if="errors[0]"
                                class="validate-error validate-error-red"
                                >{{ errors[0] }} (First letter should be
                                small)</span
                            >
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <b-row class="my-2">
                    <b-col>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="User Name"
                        >
                            <c-input
                                inputType="text"
                                inputId="username"
                                labelText="User Name *"
                                v-model="authentication.userName"
                            />
                            <span class="validate-error validate-error-red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col>
                        <div class="password-input-wrapper">
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="password"
                                vid="password"
                            >
                                <c-input
                                    :inputType="passwordInputType"
                                    inputId="pwd"
                                    labelText="Password *"
                                    v-model="authentication.password"
                                />
                                <span
                                    class="validate-error validate-error-red"
                                    >{{ errors[0] }}</span
                                >
                            </ValidationProvider>
                            <img
                                :src="
                                    passwordInputType === 'password'
                                        ? require('@/assets/icon/passwordHideIcon.svg')
                                        : require('@/assets/icon/passwordViewIcon.svg')
                                "
                                @click="togglePasswordVisibility"
                                class="password-toggle-icon"
                            />
                        </div>
                    </b-col>
                </b-row>
                <b-row class="my-3">
                    <b-col md="6">
                        <div class="password-input-wrapper">
                            <ValidationProvider
                                rules="required|confirmed:password"
                                v-slot="{ errors }"
                                name="confirm password"
                            >
                                <c-input
                                    :inputType="confirmPasswordInputType"
                                    inputId="cpwd"
                                    labelText="Confirm Password *"
                                    v-model="authentication.confirmpassword"
                                />
                                <span
                                    class="validate-error validate-error-red"
                                    >{{ errors[0] }}</span
                                >
                            </ValidationProvider>
                            <img
                                :src="
                                    confirmPasswordInputType === 'password'
                                        ? require('@/assets/icon/passwordHideIcon.svg')
                                        : require('@/assets/icon/passwordViewIcon.svg')
                                "
                                @click="toggleConfirmPasswordVisibility"
                                class="password-toggle-icon"
                            />
                        </div>
                    </b-col>
                </b-row>
            </b-card>

            <slot name="footer-button" :data="authentication"></slot>
        </ValidationObserver>
    </div>
</template>
<script>
import {
    ValidationProvider,
    ValidationObserver,
    Validator,
} from "vee-validate";
import cInput from "@/components/FormElements/CustomInput";
import cTelInput from "@/components/FormElements/MobileNumberInput";

export default {
    name: "Authentication",
    data() {
        return {
            authentication: {
                firstName: "",
                lastName: "",
                phone: "",
                email: "",
                userName: "",
                password: "Welcome@123",
                confirmpassword: "Welcome@123",
            },
            passwordInputType: "password",
            confirmPasswordInputType: "password",
        };
    },
    components: {
        cInput,
        cTelInput,
        ValidationProvider,
        ValidationObserver,
    },
    methods: {
        isValid() {
            const isValid = this.$refs.observer.validate();
            return isValid;
        },
        togglePasswordVisibility() {
            this.passwordInputType =
                this.passwordInputType === "password" ? "text" : "password";
        },
        toggleConfirmPasswordVisibility() {
            this.confirmPasswordInputType =
                this.confirmPasswordInputType === "password"
                    ? "text"
                    : "password";
        },
    },
    mounted() {
        Validator.extend("no-capital-first-letter", {
            validate(value) {
                return value[0] !== value[0].toUpperCase();
            },
        });
    },
};
</script>
<style scoped>
.password-toggle-icon {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
}
.password-input-wrapper {
    position: relative;
}
.password-input-wrapper .validate-error {
    position: absolute;
}

.validate-error-red {
    color: red;
}
</style>
